import React from 'react'

import { cva, type VariantProps } from 'class-variance-authority'

import { cn } from '@/lib/utils.ts'

import { Icons } from '../Icons/Icons.tsx'

const automatedStatusVariants = cva('size-[17px]', {
  variants: {
    variant: {
      pending: 'fill-gray-300',
      active: 'fill-green-400',
      inactive: 'fill-red-700',
    },
  },
  defaultVariants: {
    variant: 'pending',
  },
})

export interface AutomatedStatusProps
  extends React.HtmlHTMLAttributes<HTMLDivElement>, VariantProps<typeof automatedStatusVariants> {}

export const AutomatedStatus = React.forwardRef<HTMLDivElement, AutomatedStatusProps>(
  ({ className, variant, ...props }, ref) => (
    <Icons.automated className={cn(automatedStatusVariants({ variant, className }))} ref={ref} {...props} />
  )
)
